const parseCategoryLink = category => {
  const {
    link,
    customUrl,
  } = category;
  const preferredUrl = customUrl || link;
  const hash = preferredUrl.indexOf('#') > 0 ? preferredUrl.slice(preferredUrl.indexOf('#')) : '';
  const urlWithoutHash = preferredUrl.indexOf('#') > 0 ? preferredUrl.slice(0, preferredUrl.indexOf('#')) : preferredUrl;
  const parameterDivider = preferredUrl.indexOf('?') > -1 ? '&' : '?';
  const trackingParam = 'cl=true';

  return {
    ...category,
    link: `${urlWithoutHash}${parameterDivider}${trackingParam}${hash}`,
  };
};

const combineCategoryGroups = groups => groups.reduce(
  (allCategories, group) => allCategories.concat(group.children),
  []
);

const filterCategory = ({ category, currentCategory }) => !(
  category.hidden
  || category.id === currentCategory
  || category.type === 'spacer'
  || category.name.toLowerCase().indexOf('factory') !== -1
);

const findDivisionCategoryGroups = ({ divisionId, webHierarchy }) => {
  const matchesDivisionId = division => (division.id === divisionId ? division.children : false);

  return webHierarchy.map(division => {
    if (division.hasSubDivision) {
      return division.children.map(matchesDivisionId)
        .filter(bool => bool).reduce((a, b) => a.concat(b), []);
    }

    return matchesDivisionId(division);
  }).filter(bool => bool).reduce((a, b) => a.concat(b), []);
};

const getCurrentCategoryId = selectedNodes => selectedNodes
.find(({ type }) => type === 'category' || type === 'sale') || {};

const getDivisionId = selectedNodes => selectedNodes
.find(({ type }) => type === 'division' || type === 'sub-division') || {};

const categoriesBasedOnHierarchyAndNodes = (webHierarchy, selectedNodes) => {
  const { id: currentCategory } = getCurrentCategoryId(selectedNodes);
  const { id: did } = getDivisionId(selectedNodes);

  const groups = findDivisionCategoryGroups({ divisionId: did, webHierarchy });
  const combinedCategoryGroups = combineCategoryGroups(groups);

  return {currentCategory, combinedCategoryGroups }
}

const getRelatedCategories = ({ webHierarchy, selectedNodes }) => {
    const {currentCategory, combinedCategoryGroups } = categoriesBasedOnHierarchyAndNodes(webHierarchy, selectedNodes);
    return combinedCategoryGroups
    .filter(category => filterCategory({ category, currentCategory }))
    .map(category => parseCategoryLink(category));
};

const getCurrentCategory = ({ webHierarchy, selectedNodes }) => {
  const {currentCategory, combinedCategoryGroups } = categoriesBasedOnHierarchyAndNodes(webHierarchy, selectedNodes);
  return combinedCategoryGroups
  .filter(category => (category.id === currentCategory))
  .shift();
};


export {
  parseCategoryLink,
  combineCategoryGroups,
  filterCategory,
  findDivisionCategoryGroups,
  getRelatedCategories,
  getCurrentCategory,
};
